import React from 'react';
import {Grid, Stack, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";

const section = {
  "name": "AboutSection1",
  "type": "banner",
  "bannerTitle1": "Des prescriptions",
  "bannerTitle2": "Simples et pratiques",
  "bannerText1": "Nutri-Logics met à votre disposition des outils optimaux pour vous permettre de vous concentrer totalement sur votre activité : guides et bons de prescription, protocoles,  e-shop pratique et documenté...",
  "bannerText2": "De plus, nos conseillers sont à votre entière disposition pour répondre à toutes vos questions.",
  "bannerImage": `${process.env.REACT_APP_API_RESOURCES_URL}/images/Illu_Prescription.png`
};
export default function ProsSection3() {

  return (
    <Box
      sx={{
        width: '100%',
        margin: '40px 0 60px',
        padding: '1px 0',
        overflowX: 'clip',
      }}>
      <Container
        maxWidth={'xxl'}>
        <Grid container spacing={2} justifyContent={"space-between"} flexDirection={"row"} sx={{
          ml: '-8px !important',
          position: 'relative',
          py: '6vw',
        }}>
          <Grid item xs={12} sm={6}>
            <Box component={'img'} src={section.bannerImage} alt={section.bannerTitle}
              sx={{
                width: {xs: 'auto', sm: '37vw', md: '37vw', lg: '37vw', xl: '37vw', xxl: '700px'},
                maxWidth: {xs: '100%', sm: '90%'},
                position: {xs: 'inherit', sm: 'absolute', md: 'absolute'},
                bottom: {xs: '0px', sm: '0px', md: '0px'},
                top: {xs: '0px', sm: '0px', md: '0px'},
                right: {xs: 'unset', sm: 'unset', md: 'unset'},
                left: {xs: 'unset', sm: 'unset', md: 'unset'},
                display: 'block',
                margin: 'auto'
              }}/>
          </Grid>
          <Grid item xs={12} sm={6} sx={{pl: '24px', pr: '24px'}}>
            <Stack gap={2} alignItems={'flex-start'}>
              <Typography
                sx={{
                  fontFamily: 'Raleway',
                  fontWeight: '600',
                  padding: '8px 8px',
                  fontSize: {xs: '2.5rem', sm: '2rem', md: '2.5rem', lg: '3.5rem', xl: '3.5rem', xxl: '4.5rem'},
                  lineHeight: '1',
                  overflow: 'hidden',
                  color: 'green',
                  textAlign: {xs: 'left', sm: 'left'},
                  zIndex: 1,
                  '& p': {
                    margin: 0,
                  },
                  '& span': {
                    lineHeight: '1',
                    fontFamily: 'Raleway',
                    fontWeight: '600',
                    fontSize: {xs: '2.5rem', sm: '2rem', md: '2.5rem', lg: '3.5rem', xl: '3.5rem', xxl: '4.5rem'},
                  }
                }}>
                {section.bannerTitle1} <br/>
                <Typography component={"span"} sx={{color: 'primary.main'}}>{section.bannerTitle2}</Typography> <br/>
              </Typography>

              <Typography
                sx={{
                  fontSize: {xs: '1rem', sm: '0.9rem', md: '1rem', lg: '1.1rem', xl: '1.2rem', xxl: '1.3rem'},
                  padding: '0 8px 8px 8px',
                  fontFamily: 'Open Sans',
                  maxWidth: {xs: '100%', sm: '100%'},
                  lineHeight: '1.4',
                  overflow: 'hidden',
                  textAlign: 'left',
                  color: 'primary.light',
                  zIndex: 1,
                  '& p': {
                    margin: 0,
                  }
                }}>
                {section.bannerText1}
              </Typography>
              <Typography
                sx={{
                  fontSize: {xs: '1rem', sm: '0.9rem', md: '1rem', lg: '1.1rem', xl: '1.2rem', xxl: '1.3rem'},
                  padding: '0 8px 8px 8px',
                  fontFamily: 'Open Sans',
                  maxWidth: {xs: '100%', sm: '100%'},
                  lineHeight: '1.4',
                  overflow: 'hidden',
                  textAlign: 'left',
                  color: 'primary.main',
                  zIndex: 1,
                  '& p': {
                    margin: 0,
                  }
                }}>
                {section.bannerText2}
              </Typography>
            </Stack>
          </Grid>

        </Grid>
      </Container>
    </Box>
  );
}
